import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, X } from 'lucide-react';
import { Scrim } from './Scrim';
import { useLanguage } from '../functions/useLanguage';

export interface SubscriptionGateModalProps {
  open: boolean;
  onClose: () => void;
  /** Action that Co-Carers are trying to do (e.g. "add a pet", "accept ownership") */
  action: 'add_pet' | 'accept_ownership';
}

export function SubscriptionGateModal({ open, onClose, action }: SubscriptionGateModalProps) {
  const { t } = useLanguage();
  const navigate = useNavigate();

  const handleUpgrade = () => {
    onClose();
    navigate('/settings?tab=subscription');
  };

  if (!open) return null;

  return (
    <Scrim onClick={onClose} zIndex={200}>
      <div 
        className="bg-white rounded-2xl max-w-sm w-full mx-4 p-6 space-y-4"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <div className="flex justify-end">
          <button
            onClick={onClose}
            className="p-1 rounded-full hover:bg-gray-100 text-text-secondary transition-colors"
          >
            <X size={20} />
          </button>
        </div>

        {/* Icon */}
        <div className="flex justify-center -mt-2">
          <div className="w-12 h-12 rounded-full bg-primary-brown/10 flex items-center justify-center">
            <Lock size={24} className="text-primary-brown" />
          </div>
        </div>

        {/* Title */}
        <h2 className="text-lg font-bold text-center text-[#0d2744]">
          Subscription Required
        </h2>

        {/* Message */}
        <p className="text-sm text-gray-600 text-center leading-relaxed">
          {action === 'add_pet'
            ? 'Only plan owners can add pets. Co-carers must upgrade to manage their own pet profiles.'
            : 'Only plan owners can accept pet ownership. Co-carers must upgrade to own pets.'}
        </p>

        {/* Actions */}
        <div className="flex gap-3 pt-2">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2.5 rounded-xl text-sm font-semibold text-gray-600 bg-gray-100 hover:bg-gray-200 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleUpgrade}
            className="flex-1 px-4 py-2.5 rounded-xl text-sm font-semibold text-white bg-primary-brown hover:bg-primary-brown/90 transition-colors"
          >
            {t('trial.upgrade')}
          </button>
        </div>
      </div>
    </Scrim>
  );
}
